import React from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import blogImg from "../../assets/img/avoConsulteBlogImg.png";
import { formatArticleDate, magazineUrl } from "./articleHelpers";
import PathLink from "../../shared/seo/PathLink";
import { urls } from "../../shared/seo/links";
import Breadcrumbs from "../content/Breadcrumbs";
import ReadIn from "../content/ReadIn";
import SourcesBlock from "../content/SourcesBlock";
import { lastUpdated } from "@seo/sources";
import "./magazine.css";

// crumbs, siblings and category come from pages/blogs/Blog.jsx; without
// crumbs, a link back to the magazine.
export default function BlogBody(props) {
  const Lng = localStorage.getItem("lang");
  const { t } = useTranslation();
  const blog = props?.blog || {};
  const category = props.category;
  const lang = urls.blogLang(blog, Lng);
  const updated = lastUpdated(blog);

  return (
    <article className="avc-article">
      {props.crumbs ? (
        <Breadcrumbs items={props.crumbs} />
      ) : (
        <Link to={magazineUrl(Lng)} className="avc-article__back">
          <i
            className={Lng === "ar" ? "fas fa-arrow-right" : "fas fa-arrow-left"}
            aria-hidden="true"
          ></i>
          {t("back_to_magazine")}
        </Link>
      )}
      {category ? (
        <PathLink to={urls.categoryPath(category, urls.blogLang(blog, Lng))} className="avc-tag">
          {blog.category}
        </PathLink>
      ) : (
        blog.category && <span className="avc-tag">{blog.category}</span>
      )}
      <h1 className="avc-article__title">{blog.title}</h1>
      <div className="avc-article__meta">
        <span className="avc-article__author">
          <i className="fas fa-balance-scale" aria-hidden="true"></i>
          {blog?.user?.nameInArabic ?? t("magazine_author")}
        </span>
        {blog.createdAt && (
          <time dateTime={blog.createdAt}>
            {formatArticleDate(blog.createdAt, Lng)}
          </time>
        )}
      </div>
      <ReadIn siblings={props.siblings} lang={urls.blogLang(blog, Lng)} />
      {blog.title && (
        <figure className="avc-article__cover">
          {/* Above the fold: not lazy, but sized so the text does not jump (covers are 1200x675). */}
          <img
            width="1200"
            height="675"
            src={blog.image || blogImg}
            onError={(e) => {
              e.target.src = blogImg;
            }}
            alt=""
          />
        </figure>
      )}
      <div
        className="avc-article__content"
        dangerouslySetInnerHTML={{ __html: blog.body }}
      />
      <SourcesBlock sources={blog.sources} />
      {updated && (
        <p className="avc-article__updated">
          {t("article_last_updated")}
          {lang === "fr" ? " : " : ": "}
          <time dateTime={updated.toISOString()}>{formatArticleDate(updated, lang)}</time>
        </p>
      )}
    </article>
  );
}
